import z from "zod"

export const ZendeskWebhookParamsSchema = z.object({
  companySlug: z.string().min(1),
})

export const ZendeskTicketStatusWebhookSchema = z.object({
  type: z.literal("zen:event-type:ticket.status_changed"),
  detail: z.object({
    id: z.union([z.string(), z.number()]),
    status: z.enum([
      "NEW",
      "OPEN",
      "PENDING",
      "HOLD",
      "SOLVED",
      "CLOSED",
      "DELETED",
      "ARCHIVED",
      "SCRUBBED",
    ]),
  }),
})
